/**
 * Who owns a hired truck: a supplier (Sundry Creditors), because the
 * business pays them. Alt+C in the box, or the link under it, adds a new
 * one without leaving the screen -- the same key as a new customer on
 * trip invoicing.
 */
import { useState } from 'react'
import { Box, ButtonBase, Stack, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import Keycap from '../components/Keycap'
import { c } from '../theme'
import CreatePartyDialog from '../vouchers/CreatePartyDialog'
import LedgerPicker from '../vouchers/LedgerPicker'

export default function SubcontractorPicker(
  { value, onChange }: { value: string; onChange: (code: string) => void },
) {
  const { t } = useTranslation()
  const [creating, setCreating] = useState<string | null>(null)
  return (
    <Box sx={{ position: 'relative', minWidth: 220 }}>
      <Typography sx={{ fontSize: 11, color: c.inkMuted, mb: 0.5 }}>
        {t('fleet.subcontractor')}
      </Typography>
      <LedgerPicker value={value} onChange={onChange} groups={['CREDIT']}
        onCreateRequest={(typed) => setCreating(typed)}
        placeholder={t('fleet.subcontractorPlaceholder')} />
      <ButtonBase onClick={() => setCreating('')}
        sx={{ mt: 0.5, gap: 0.5, borderRadius: 1 }}>
        <Stack direction="row" spacing={0.5} alignItems="center">
          <Keycap combo="alt+c" />
          <Typography sx={{ fontSize: 11.5, color: c.inkMuted }}>
            {t('fleet.newSubcontractor')}</Typography>
        </Stack>
      </ButtonBase>
      <CreatePartyDialog open={creating !== null} initialName={creating ?? ''}
        defaultKind="supplier" fixedKind title={t('fleet.newSubcontractor')}
        onClose={() => setCreating(null)}
        onCreated={(led) => onChange(led.code)} />
    </Box>
  )
}
